import {
    getManageUserComments
    , setManageUserError
    , insertManageUserComment
    , resetManageUserComments
} from "../../../constants/model-reducers/external/manage-user/manage-user-comments.settings";
import { updateOutputColumnsDatatable } from "../../../constants/model-reducers/external/recharge/output-configuration/output-configuration-details.settings";
import { httpGet, httpPost, httpPostFile, httpDownload } from "../../../utils/api.utils";

const defaultState = () => ({
    manageUserComments: []
    , pageIndex: 1
    , hasMoreComments: true
});

const initialState = defaultState();

export const manageUserCommentActions = {
    postManageUserComments: (employeeID, fileName, fileData, comment) => async (dispatch, state) => {
        var formData = new FormData();

        if (fileData.length > 0) {
            fileData.forEach((element) => formData.append("FileData", element));
            formData.append("FileName", JSON.stringify(fileName));
        }

        formData.append("Comment", comment.toString());
        formData.append("UserId", parseInt(sessionStorage.getItem('UserID')),);
        formData.append("EmployeeID", employeeID);

        var res = await httpPostFile('external/manageUser/setManageUserComments', formData);

        if (res != null) {
            dispatch({
                type: insertManageUserComment,
                manageUserComments: res.manageUserComments,
                isManageUserCommentLoaded: true,
                isManageUserCommentError: false
            });
        } else {
            dispatch({
                type: setManageUserError,
                isManageUserCommentError: true,
                isManageUserCommentLoaded: false
            });
        }
    },

    getManageUserComments: (employeeID, pageIndex = 1, pageSize = 5) => async (dispatch, state) => {
        const { manageUserComments } = state().manageUserComments

        const existingComments = manageUserComments || [];
        const lastCommentId = existingComments.length > 0
            ? existingComments[existingComments.length - 1].CommentID
            : null;

        var res = await httpGet(
            `external/manageUser/getManageUserComments/${pageIndex}/${pageSize}?employeeID=${employeeID}` +
            (lastCommentId != null ? `&lastCommentId=${lastCommentId}` : "")
        );

        if (res != null) {
            dispatch({
                type: getManageUserComments,
                manageUserComments: res.manageUserComments,
                isManageUserCommentLoaded: true,
                isManageUserCommentError: false,
                pageIndex: pageIndex,
                hasMoreData: res.hasMoreData
            });
        } else {
            dispatch({
                type: setManageUserError,
                isManageUserCommentError: true,
                isManageUserCommentLoaded: false
            });
        }
    },

    deleteManageUserComments: (commentId) => async (dispatch, state) => {
        var userId = sessionStorage.getItem("UserID")
        var res = await httpPost('external/manageUser/deleteManageUserComment/' + commentId + '/' + userId);

        if (res == null) {
            dispatch({
                type: setManageUserError,
                isManageUserCommentError: true,
                isManageUserCommentLoaded: false
            });
        }
    },

    resetManageUserComments: () => (dispatch) => {
        dispatch({
            type: resetManageUserComments,
        })
    },
}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case getManageUserComments: {
            return {
                ...state,
                manageUserComments: [
                    ...state.manageUserComments,
                    ...action.manageUserComments
                ]
                , hasMoreComments: action.hasMoreData,
                pageIndex: action.pageIndex
            };
        }
        case setManageUserError: {
            return {
                ...state,
                isManageUserCommentError: action.isManageUserCommentError,
                isManageUserCommentLoaded: action.isManageUserCommentLoaded
            }
        }
        case insertManageUserComment: {
            const combinedComments = [
                ...action.manageUserComments,
                ...state.manageUserComments
            ];

            const currentVisibleCount = state.manageUserComments.length;
            const currentDisplayLimit = Math.ceil(currentVisibleCount / 5) * 5;
            const hasMore = combinedComments.length > currentDisplayLimit && combinedComments.length !==1;
            let updatedComments; 
            if (hasMore) {
                updatedComments = combinedComments.slice(0, -1);
            } else {
                updatedComments = combinedComments;
            }
            return {
                ...state,
                manageUserComments: combinedComments.length ===1 ? action.manageUserComments : updatedComments,
                hasMoreComments: hasMore,
            };
        }
        case resetManageUserComments:
            return {
                ...state,
                manageUserComments: [],
                hasMoreComments: false,
                pageIndex: 1
            }
        default:
            return state;
    }
}